import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Footer from '../../Include/Footer';
import { Link } from 'react-router-dom';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import Loader from '../../Include/Loader';
import { Pagination, Search } from '../../Table';
import DropDown from '../../../../Components/DropDown';
import { getProPoPending } from '../../../../Store/prosafe/proReport/getProPoPending';

const ProPoPending = () => {

    const dispatch = useDispatch();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [disable, setDisable] = useState(true);

    useEffect(() => {
        if (disable === true) {
            const formData = new URLSearchParams();
            formData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
            formData.append('tag_number', 10);
            dispatch(getProPoPending({ formData }))
            setDisable(false);
        }
    }, [disable]);

    const entity = useSelector((state) => state?.getProPoPending?.user?.data);

    const commentsData = useMemo(() => {
        let computedComments = entity || [];
        if (search.trim() !== "") {
            const lowerSearch = search.toLowerCase();
            computedComments = computedComments.filter((item) =>
                item?.item_data?.name?.toLowerCase().includes(lowerSearch) ||
                item?.po_no?.toLowerCase().includes(lowerSearch) ||
                item?.item_no?.toLowerCase().includes(lowerSearch)
            );
        }
        setTotalItems(computedComments?.length);
        return computedComments?.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );
    }, [currentPage, search, limit, entity]);

    const handleRefresh = () => {
        setDisable(true);
        setSearch('');
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/main-store/user/dashboard">Dashboard </Link></li>
                                    <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                                    <li className="breadcrumb-item active">PO Pending List</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {disable === false ? (
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card card-table show-entire">
                                    <div className="card-body">
                                        <div className="page-table-header mb-2">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <div className="doctor-table-blk">
                                                        <h3>PO Pending List</h3>
                                                        <div className="doctor-search-blk">
                                                            <div className="top-nav-search table-search-blk">
                                                                <form>
                                                                    <Search
                                                                        onSearch={(value) => {
                                                                            setSearch(value);
                                                                            setCurrentPage(1);
                                                                        }}
                                                                    />
                                                                    {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                                                    <a className="btn">
                                                                        <img src="/assets/img/icons/search-normal.svg" alt="firm-searchBox" />
                                                                    </a>
                                                                </form>
                                                            </div>
                                                            <div className="add-group">
                                                                <button type="button" onClick={handleRefresh} className="btn btn-primary doctor-refresh ms-2"
                                                                    data-toggle="tooltip" data-placement="top" title="Refresh">
                                                                    <img src="/assets/img/icons/re-fresh.svg" alt="refresh" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                                                    <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table border-0 custom-table comman-table  mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>PO No</th>
                                                        <th>Item No</th>
                                                        <th>Item Name</th>
                                                        <th>Quantity</th>
                                                        <th>Received Qty</th>
                                                        <th>Balance Qty</th>
                                                        <th>Item Length</th>
                                                        <th>Item Width</th>
                                                        <th>Item Weight</th>
                                                        <th>Item Radius</th>
                                                        <th>Item Thickness</th>
                                                        <th>Assembly Weight</th>
                                                        <th>Assembly Surface Area</th>
                                                        <th>Rate (₹)</th>
                                                        <th>GST (%)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {commentsData?.map((elem, i) =>
                                                        <tr key={i}>
                                                            <td>{(currentPage - 1) * limit + i + 1}</td>
                                                            <td>{elem?.po_no || "-"}</td>
                                                            <td>{elem?.item_no || "-"}</td>
                                                            <td>{elem?.item_data?.name || "-"}</td>
                                                            <td>{elem?.quantity ?? "-"}</td>
                                                            <td>{(elem?.quantity - elem.balance_qty) ?? "-"}</td>
                                                            <td>{elem?.balance_qty ?? "-"}</td>
                                                            <td>{elem?.item_length ?? "-"}</td>
                                                            <td>{elem?.item_width ?? "-"}</td>
                                                            <td>{elem?.item_weight ?? "-"}</td>
                                                            <td>{elem?.item_radius ?? "-"}</td>
                                                            <td>{elem?.item_thickness ?? "-"}</td>
                                                            <td>{elem?.assembly_weight ?? "-"}</td>
                                                            <td>{elem?.assembly_surface_area ?? "-"}</td>
                                                            <td>{elem?.rate ?? "-"}</td>
                                                            <td>{elem?.gst ?? "-"}</td>

                                                        </tr>
                                                    )}
                                                    {commentsData?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="999">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row align-center mt-3 mb-2">
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                                <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                    aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                                <div className="dataTables_paginate paging_simple_numbers"
                                                    id="DataTables_Table_0_paginate">
                                                    <Pagination
                                                        total={totalItems}
                                                        itemsPerPage={limit}
                                                        currentPage={currentPage}
                                                        onPageChange={(page) => setCurrentPage(page)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : <Loader />}

                </div>
                <Footer />
            </div>
        </div>
    )
}

export default ProPoPending